import React from "react";
import Svg, { Path } from "svgs";

import { Icon } from "../../types";

const Help = ({ size, color, ...props }: Icon) => (
  <Svg
    {...props}
    viewBox="0 0 29.536 29.536"
    width={size}
    height={size}
    fill={color}
  >
    <Path
      fill={color}
      d="M14.768 0C6.611 0 0 6.609 0 14.768c0 8.155 6.611 14.767 14.768 14.767s14.768-6.612 14.768-14.767C29.535 6.609 22.924 0 14.768 0zm0 27.126c-6.828 0-12.361-5.532-12.361-12.359 0-6.828 5.533-12.362 12.361-12.362 6.826 0 12.359 5.535 12.359 12.362s-5.533 12.359-12.359 12.359z"
    />
    <Path
      fill={color}
      d="M14.385 19.337c-1.338 0-2.289.951-2.289 2.34 0 1.336.926 2.339 2.289 2.339 1.414 0 2.314-1.003 2.314-2.339-.027-1.389-.928-2.34-2.314-2.34zM14.742 6.092c-1.824 0-3.34.513-4.293 1.053l.875 2.804c.668-.462 1.697-.772 2.545-.772 1.285.027 1.879.644 1.879 1.543 0 .85-.67 1.697-1.494 2.701-1.156 1.364-1.594 2.701-1.516 4.012l.025.669h3.42v-.463c-.025-1.158.387-2.162 1.311-3.215.979-1.08 2.211-2.366 2.211-4.321 0-2.135-1.566-4.011-4.963-4.011z"
    />
  </Svg>
);

Help.displayName = "Help";

Help.defaultProps = {
  size: 16,
  color: "currentcolor",
};

export default Help;
